import { rest, ResponseData } from '@/ajax';

export async function getPromoCodeList(): Promise<ResponseData<any>> {
  return rest.operationPromotion.getPromoCode();
}

export default {};
